import { useApi } from "lib/apiFetcher";

export const useAccountGetProfileApi = () => useApi("get", "/profile");
export const useAccountUpdateProfileApi = () => useApi("put", "/profile");
export const useAccountUpdatePasswordApi = () =>
  useApi("put", "/profile/password");
export const useAccountDeleteProfileApi = () => useApi("delete", "/profile");
